import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheck, CheckCircle2, Sparkles, BotMessageSquare } from 'lucide-react';
export function PricingSection() {
  return <Section background="rose" id="pricing" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <div className="text-center mb-12" data-id="element-104">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-105">
            Elige tu nivel de acceso
          </h2>
          <p className="text-lg text-gray-600" data-id="element-106">
            Comienza a comunicarte con seguridad hoy mismo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-start max-w-4xl mx-auto" data-id="element-107">
          {/* Tier 1: Ebook + Bonos */}
          <div className="bg-white rounded-3xl shadow-lg border border-rose-100 p-8 flex flex-col h-full order-2 md:order-1" data-id="element-108">
            <div className="mb-6" data-id="element-109">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-110">
                Ebook + Bonos
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-111">
                Todo lo que necesitas para empezar.
              </p>
            </div>

            <div className="flex items-center gap-2 mb-6" data-id="element-112">
              <span className="text-4xl font-extrabold text-gray-900" data-id="element-113">
                $17.99
              </span>
              <span className="text-lg text-gray-400 line-through font-medium" data-id="element-114">
                $47
              </span>
            </div>

            <div className="flex justify-center mb-6" data-id="element-115">
              <img src="https://cdn.magicpatterns.com/uploads/6mHR95aYqiKteTwzfHgtr4/ChatGPT_Image_31_ene_2026,_03_36_32_p.m..png" alt="Portada del ebook Di Esto, No Aquello™" className="w-32 rounded-xl shadow-md" data-id="element-116" />
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-117">
              <li className="flex items-start gap-3" data-id="element-118">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-119" />
                <span className="text-gray-700 font-medium" data-id="element-120">
                  Ebook Di Esto, No Aquello™
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-121">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-122" />
                <span className="text-gray-700" data-id="element-123">
                  Bono 1: Guía de Mensajes de Texto
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-124">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-125" />
                <span className="text-gray-700" data-id="element-126">
                  Bono 2: Qué Decir Cuando Él Se Cierra
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-127">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-128" />
                <span className="text-gray-700" data-id="element-129">
                  Bono 3: Scripts de Emergencia
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-130">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-131" />
                <span className="text-gray-700" data-id="element-132">Descarga inmediata</span>
              </li>
            </ul>

            <CTAButton fullWidth className="py-4 bg-gray-900 hover:bg-gray-800 text-white shadow-none" onClick={() => window.open('https://pay.hotmart.com/H104303411I?checkoutMode=10', '_blank')} data-id="element-133">
              Descargar Ebook + Bonos
            </CTAButton>
          </div>

          {/* Tier 2: Ebook + Bonos + Dra Sophi */}
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-rose-500 p-8 flex flex-col h-full relative md:scale-105 z-10 order-1 md:order-2" data-id="element-134">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-rose-500 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide flex items-center gap-1 shadow-md whitespace-nowrap" data-id="element-135">
              <Sparkles className="h-4 w-4" data-id="element-136" />
              Más Popular
            </div>

            <div className="mb-6" data-id="element-137">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-138">
                Ebook + Dra Sophi™
              </h3>
              <p className="text-rose-600 text-sm font-medium" data-id="element-139">
                La experiencia completa con IA.
              </p>
            </div>

            <div className="flex items-center gap-2 mb-6" data-id="element-140">
              <span className="text-4xl font-extrabold text-gray-900" data-id="element-141">
                $37.99
              </span>
              <span className="text-lg text-gray-400 line-through font-medium" data-id="element-142">
                $97
              </span>
            </div>

            <div className="bg-rose-50 rounded-2xl p-5 mb-6 border border-rose-100" data-id="element-143">
              <div className="flex items-center gap-3 mb-3" data-id="element-144">
                <div className="bg-rose-500 p-2 rounded-lg text-white" data-id="element-145">
                  <BotMessageSquare className="h-6 w-6" data-id="element-146" />
                </div>
                <h4 className="font-bold text-gray-900" data-id="element-147">Dra Sophi™</h4>
              </div>
              <p className="text-sm text-gray-700 mb-4 italic" data-id="element-148">
                "Tu mentora personal que te dice exactamente qué decir en los
                momentos más difíciles — en tiempo real, sin juicio, sin esperar
                cita."
              </p>
              <ul className="space-y-2" data-id="element-149">
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-150">
                  <span className="text-rose-500 font-bold" data-id="element-151">•</span>
                  Respuestas personalizadas para TU situación real
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-152">
                  <span className="text-rose-500 font-bold" data-id="element-153">•</span>
                  Disponible 24/7 — como tener una coach en tu bolsillo
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-154">
                  <span className="text-rose-500 font-bold" data-id="element-155">•</span>
                  Pregúntale: "¿Qué le digo si me dejó en visto?"
                </li>
              </ul>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-156">
              <li className="flex items-start gap-3" data-id="element-157">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-158" />
                <span className="text-gray-900 font-bold" data-id="element-159">
                  Acceso a Dra Sophi™ (Agente IA)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-160">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-161" />
                <span className="text-gray-700" data-id="element-162">
                  Ebook Di Esto, No Aquello™
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-163">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-164" />
                <span className="text-gray-700" data-id="element-165">Los 3 Bonos de Regalo</span>
              </li>
            </ul>

            <CTAButton fullWidth className="py-4 text-lg shadow-rose-200" onClick={() => window.open('https://pay.hotmart.com/H104303411I?off=wqzh9j0e&checkoutMode=10&bid=1775166209201', '_blank')} data-id="element-166">
              Quiero el Ebook + Dra Sophi™
            </CTAButton>
          </div>
        </div>

        <div className="mt-12 flex items-center justify-center gap-2 text-gray-500 text-sm max-w-lg mx-auto text-center" data-id="element-167">
          <ShieldCheck className="h-6 w-6 text-green-500 flex-shrink-0" data-id="element-168" />
          <span data-id="element-169">
            Garantía de satisfacción de 14 días en ambos planes. Si no te sirve,
            te devolvemos tu dinero.
          </span>
        </div>
      </div>
    </Section>;
}